import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';
import snakeCaseKeys from 'snakecase-keys';
import { Button, Row, Col, Form, Spinner, Card, Tab, Nav } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { useParams } from 'react-router-dom';
import { AbilityContext } from '../../config/abilityContext';
import { useAuthorization } from '../../services/hooks';
import { sendAlert, setAdvanceSettings } from '../../actions/utils';
import { renderGrid, remCardBody, renderRemGrid } from './AdvanceSettingsRenders';
import {
  BasicTooltip,
  FormikNumber,
  FormikSelect,
  Icon,
  UploadImage,
  DefaultModal,
  ButtonTooltip
} from '../../components';
import {
  indexAdvanceSettingsRequest,
  advanceSettingAdvancePaymentsRequest,
  updateAdvanceSettingRequest
} from '../../requests/advanceSettings';
import {
  showCompanyRequest,
  updateCompanyRequest,
  exportCompanyRequest,
  generateSecretKeyCompanyRequest
} from '../../requests/companies';
import { validateToken } from '../../actions/auth';
import './style.scss';
import {
  listedSettings,
  selectorOptions,
  employeeProfile,
  notifications,
  ctEmployeeProfile,
  ctNotifications,
  ctAdditionalSettings,
  conditionsEnum,
  listedRemunerationsSettings
} from './CardInfo';
import { hideString } from '../../services/utils';
import { generateSecretKeyAdminCompanyRequest } from '../../requests/adminCompanies';
import FormAdvancePayment from './FormAdvancePayment';
import LoanFormSettings from '../LoanSettings/LoanFormSettings';
import ModalLoanSettings from '../LoanSettings/ModalLoanSettings';
import FieldWorkdayReportEarlyOvertimeEffectiveDate from './FieldWorkdayReportEarlyOvertimeEffectiveDate';
import FormOvertimeRequests from './FormOvertimeRequests';
import FormNightShiftSettings from './FormNightShiftSettings';
import SettingsCard from '../../components/Utils/Cards/SettingsCard';
import {
  createAnnualGratificationSettingsRequest,
  updateAnnualGratificationSettingsRequest
} from '../../requests/annualGratificationSettings';
import AnnualGratificationSettingsForm from '../Settings/Annual/AnnualGratificationSettingsForm';

const AdvanceSettings = props => {
  const dispatch = useDispatch();
  const childRef = useRef();
  const ability = useAbility(AbilityContext);
  const [onRequest, setOnRequest] = useState(false);
  const [settingData, setSettingData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [advancePayment, setAdvancePayment] = useState([]);
  const [advancePaymentLoan, setAdvancePaymentLoan] = useState([]);
  const [overtimeRequests, setOvertimeRequests] = useState([]);
  const [nightShiftSettings, setNightShiftSettings] = useState([]);
  const [modalShowApiCredentials, setModalShowApiCredentials] = useState(false);
  const [modalBodyApiCredentials, setModalBodyApiCredentials] = useState('');
  const [modalTitleApiCredentials, setModalTitleApiCredentials] = useState('');
  const [initialSettingData, setInitialSettingData] = useState([]);
  const [companyLogo, setCompanyLogo] = useState({});
  const [logoUpdateButton, setLogoUpdateButton] = useState(false);
  const getSetting = code => settingData.find(s => s.code === code);
  const isEnabled = code => getSetting(code)?.textValue === 'true';
  const params = useParams();
  const { id } = params;
  const companyId = id || localStorage.getItem('currentCompany');
  const canUpdateSettings = useAuthorization('update', 'AdvanceSetting');
  const { currentCompany, ongoingRequest, company } = useSelector(state => state.auth);
  const [showSecretKey, setShowSecretKey] = useState(false);
  const [withModalConfirm, setWithModalConfirm] = useState(true);
  const [currentSecretKey, setCurrentSecretKey] = useState('');
  const [closeBtnMsg, setCloseBtnMsg] = useState('Cancelar');
  const [loanSetting, setLoanSetting] = useState({});
  const { admin, isProfile } = props;
  const { apiKey, secretKey } = company;
  const secretBtnIcon = showSecretKey ? 'eye-off' : 'eye';
  const secretBtnMsg = showSecretKey ? 'Ocultar' : 'Mostrar';
  const [activeTab, setActiveTab] = useState('people');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (values, setSubmitting, setFieldValue) => {
    setIsLoading(true);
    setSubmitting(true);
    const formatedValues = snakeCaseKeys(values);
    if (values?.annualGratificationSetting?.id) {
      updateAnnualGratificationSettingsRequest(values?.annualGratificationSetting?.id, {
        dispatch,
        params: formatedValues,
        successCallback: () => {
          dispatch(sendAlert({ kind: 'success', message: 'Ajustes actualizados correctamente' }));
          setIsLoading(false);
          setSubmitting(false);
        },
        failureCallback: () => {
          setIsLoading(false);
          setSubmitting(false);
        },
        callback: () => {
          setIsLoading(false);
          setSubmitting(false);
        }
      });
      return;
    }

    createAnnualGratificationSettingsRequest({
      dispatch,
      params: formatedValues,
      successCallback: ({ data }) => {
        dispatch(sendAlert({ kind: 'success', message: 'Ajustes creados correctamente' }));
        setFieldValue('annualGratificationSetting[id]', data?.id);
        setIsLoading(false);
        setSubmitting(false);
      },
      failureCallback: () => {
        setIsLoading(false);
        setSubmitting(false);
      },
      callback: () => {
        setIsLoading(false);
        setSubmitting(false);
      }
    });
  };

  const hiddenSecretKey = currentSecretKey?.length ? hideString(currentSecretKey, currentSecretKey.length - 7) : '';
  const modalsWithButtons = [
    'Comenzar Exportación de Empresa',
    'Desconectar Usuario DT',
    'HABILITAR SOLICITUD DE PRÉSTAMO'
  ];
  // eslint-disable-next-line no-unused-vars
  let vListedSettings = listedSettings;

  const yearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => ({
      label: `${currentYear - i}`,
      value: currentYear - i
    }));
    return years;
  };

  const handleNewSecretKeyModal = () => {
    const newModalTitle = 'Nueva secret key';
    const newModalBody = '¿Estás seguro que deseas crear una nueva secret key?';
    setWithModalConfirm(true);
    setModalShowApiCredentials(true);
    setCloseBtnMsg('Cancelar');
    setModalTitleApiCredentials(newModalTitle);
    setModalBodyApiCredentials(newModalBody);
  };

  const handleSuccessNewSecretRequest = response => {
    const { secretKey: newSecretKey } = camelCaseRecursive(response?.data);
    const newModalBody = (
      <p className="mb-0">
        Tu nueva secret key es: <b>{newSecretKey}</b>
      </p>
    );

    setWithModalConfirm(false);
    setCloseBtnMsg('Cerrar');
    setModalBodyApiCredentials(newModalBody);
    setCurrentSecretKey(newSecretKey);
    setOnRequest(false);
  };

  const handleFailureRequest = error => {
    const { response } = error;
    setModalShowApiCredentials(false);
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleNewSecretKeyRequest = () => {
    const allParams = {
      dispatch,
      successCallback: handleSuccessNewSecretRequest,
      failureCallback: handleFailureRequest
    };

    if (admin) generateSecretKeyAdminCompanyRequest(companyId, allParams);
    else generateSecretKeyCompanyRequest(companyId, allParams);
    setOnRequest(true);
  };

  if (!ability.can('manage', 'attendance_management')) {
    vListedSettings = listedSettings.filter(item => item.name !== 'mobile_assistance_distance');
  }

  const handleSuccessUpdate = message => {
    dispatch(setAdvanceSettings());
    dispatch(sendAlert({ kind: 'success', message }));
  };

  const settingUpdate = (advanceSetting, isLoanSetting = false) => {
    updateAdvanceSettingRequest(advanceSetting.id, {
      dispatch,
      params: snakeCaseKeys({ advanceSetting }),
      formData: true,
      successCallback: () => {
        if (isLoanSetting) {
          setOnRequest(false);
          setModalShow(false);
        }
        handleSuccessUpdate('Configuración modificada con éxito');
      }
    });
  };

  const companyLogoUpdate = () => {
    const companyData = { company: { logo: companyLogo } };
    updateCompanyRequest(companyId, {
      dispatch,
      params: companyData,
      formData: true,
      successCallback: () => handleSuccessUpdate('Logo empresa modificado con éxito')
    });
    setLogoUpdateButton(false);
  };

  const fetchAdvancePayments = () => {
    advanceSettingAdvancePaymentsRequest({
      dispatch,
      params: {
        /* NOTA:  No incluir aqui otra cosa distinta a anticipo */
        codes: [
          'advance_payment_amount_limit',
          'advance_payment_percentage_limit',
          'limit_day_advance_payment',
          'advance_payment_payday',
          'loan_amount_limit',
          'loan_percentage_limit'
        ]
      },
      successCallback: response => {
        /* NOTA:  No incluir aqui otra cosa distinta a anticipo */
        setAdvancePayment(response.data.filter(setting => !setting.code.includes('loan')));
        setAdvancePaymentLoan(response.data.filter(setting => setting.code.includes('loan')));
      }
    });
  };
  const order = [
    'night_shift_range',
    'night_shift_start_time',
    'night_shift_end_time'
  ];
  const settingIndex = () => {
    indexAdvanceSettingsRequest({
      dispatch,
      successCallback: response => {
        setSettingData(camelCaseRecursive(response.data));
        setInitialSettingData(camelCaseRecursive(response.data));
        setOvertimeRequests(response.data.filter(setting => setting.code.includes('hour_value_overtime_requests')));
        const filteredAndOrdered = order
          .map(code => response.data.find(setting => setting.code === code))
          .filter(Boolean); // para eliminar cualquier undefined si no existe

        setNightShiftSettings(filteredAndOrdered);
      }
    });
    fetchAdvancePayments();
  };

  const companyShow = () => {
    showCompanyRequest(companyId, {
      dispatch,
      successCallback: response => setCompanyLogo(response.data.business_logo)
    });
  };

  const changeSetting = (settIndex, settValue, inputType) => {
    const newSettData = [...settingData];
    if (inputType) {
      newSettData[settIndex].integerValue = settValue;
    } else {
      newSettData[settIndex].textValue = String(!settValue);
    }
    setSettingData(newSettData);
    return newSettData[settIndex];
  };

  const changeSettingSelector = (settIndex, settValue) => {
    const next = [...settingData];
    next[settIndex].textValue = settValue;
    setSettingData(next);
  };

  const changeInitialSetting = (settIndex, settValue) => {
    const newSettData = [...initialSettingData];
    newSettData[settIndex].integerValue = settValue;
    setInitialSettingData(newSettData);
  };

  const handleModal = (body, title) => {
    setModalBody(body);
    setModalTitle(title);
    setModalShow(true);
  };

  const downloadModalBody = () => (
    <>
      <p>Comenzar el proceso de exportación</p>
      <ul>
        <li>
          La recopilación de la información se procederá en nuestros servidores, esto puede tardar varios minutos o
          incluso horas dependiendo de la cantidad de información considerada.
        </li>
        <li>Recibirás un email con un link de descarga adjunto cuando el proceso este completo.</li>
        <li>Procura realizar la descarga con una conexión segura y estable de internet.</li>
      </ul>
    </>
  );

  const handleExportCompany = () => {
    setOnRequest(true);
    exportCompanyRequest(companyId, {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Proceso de descarga iniciado con éxito.' }));
        dispatch(validateToken());
      },
      callback: () => {
        setOnRequest(false);
        setModalShow(false);
      }
    });
  };

  const modalHandleConfirm = () => {
    switch (modalTitle) {
      case 'Comenzar Exportación de Empresa':
        handleExportCompany();
        setModalShow(false);
        break;
      case 'Desconectar Usuario DT':
        childRef.current.handleDeactivateUser();
        setModalShow(false);
        break;
      case 'HABILITAR SOLICITUD DE PRÉSTAMO':
        setOnRequest(true);
        settingUpdate(loanSetting, true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  const handleCardToggleChange = (settIndex, checked) => {
    const updated = changeSetting(settIndex, checked);
    settingUpdate(updated);
  };

  const handleLoanSettingsUpdate = _loanSetting => {
    handleModal(<ModalLoanSettings />, 'HABILITAR SOLICITUD DE PRÉSTAMO');
    setLoanSetting(_loanSetting);
  };

  const cardBody = ({ text, name, tooltipText, inputType }) => {
    const isToggle = inputType === 'toggle';
    let settIndex = '';
    if (settingData.length) {
      settIndex = settingData.findIndex(value => value.code === name);
      if (settIndex < 0) settIndex = '';
    }
    const checked = settingData[settIndex]?.textValue === 'true';

    return (
      <>
        <Row>
          <Col sm={isToggle ? 9 : 8} md={12} lg={isToggle ? 6 : 5} xl={isToggle ? 8 : 7}>
            <p className="text-uppercase mt-1" style={{ letterSpacing: '1.5px' }}>
              {text}
            </p>
          </Col>
          <Col
            xs={6}
            sm={isToggle ? 2 : 3}
            md={6}
            lg={isToggle ? 4 : 5}
            xl={isToggle ? 3 : 4}
            className={`${isToggle ? 'd-flex justify-content-lg-end' : ''}`}
          >
            {inputType === 'input' && (
              <>
                {name === 'workday_report_early_overtime_effective_date' ? (
                  <FieldWorkdayReportEarlyOvertimeEffectiveDate
                    item={settingData[settIndex]}
                    initialItemData={initialSettingData[settIndex]}
                    canUpdateSettings={canUpdateSettings}
                    settingUpdate={settingUpdate}
                  />
                ) : (
                  <FormikNumber
                    fieldName=""
                    label=""
                    disabled={!canUpdateSettings}
                    value={settingData[settIndex]?.integerValue || '0'}
                    onChange={data => {
                      changeSetting(settIndex, data.target.value.replaceAll('.', ''), inputType !== 'toggle');
                    }}
                  />
                )}
                {initialSettingData[settIndex]?.integerValue !== settingData[settIndex]?.integerValue && (
                  <div style={{ marginLeft: '5px' }}>
                    <Icon
                      width={22}
                      disabled={!canUpdateSettings}
                      className="as-button text-warning"
                      icon="close-circle"
                      onClick={() =>
                        changeSetting(settIndex, initialSettingData[settIndex].integerValue, inputType !== 'toggle')
                      }
                    />
                    <Icon
                      width={22}
                      disabled={!canUpdateSettings}
                      className="as-button text-primary"
                      icon="checkmark-circle"
                      onClick={() => {
                        changeInitialSetting(settIndex, settingData[settIndex].integerValue);
                        settingUpdate(settingData[settIndex]);
                      }}
                    />
                  </div>
                )}
              </>
            )}
            {isToggle && (
              <>
                <Form.Group className="mt-1">
                  <Form.Check
                    id={`checkbox-${settIndex}`}
                    disabled={!canUpdateSettings}
                    checked={checked}
                    className={canUpdateSettings ? 'as-checkbox' : 'as-checkbox-disabled'}
                    label=""
                    type="switch"
                    onChange={() => {
                      handleCardToggleChange(settIndex, checked, name);
                    }}
                  />
                </Form.Group>
              </>
            )}
            {inputType === 'selector' && (
              <FormikSelect
                label=""
                options={selectorOptions[settingData[settIndex]?.code]}
                isDisabled={!canUpdateSettings}
                placeholder={settingData[settIndex]?.integerValue || '0'}
                onChange={data => {
                  changeSetting(settIndex, data.value, inputType !== 'toggle');
                  settingUpdate(settingData[settIndex]);
                }}
              />
            )}
          </Col>
          {tooltipText && (
            <Col className="d-flex justify-content-end">
              <Form.Label className="position-sm-absolute mt-2 mb-0">
                <BasicTooltip text={tooltipText}>
                  <Icon icon="help-circle" width={20} />
                </BasicTooltip>
              </Form.Label>
            </Col>
          )}
        </Row>
      </>
    );
  };

  useEffect(() => {
    setCurrentSecretKey(secretKey);
  }, [secretKey]);
  useEffect(settingIndex, []);
  useEffect(companyShow, []);

  return (
    <>
      {onRequest ||
        (ongoingRequest.validateToken && (
          <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
            <Spinner animation="border" variant="primary" />
          </div>
        ))}
      <Row className="mt-4 mb-2">
        <Col>
          <h2 className="mt-3 mb-3">Ajustes</h2>
        </Col>
      </Row>
      <h4 className="text-uppercase mt-3 mb-3">Logo Empresa</h4>
      <Row>
        <Col md={8}>
          <UploadImage
            disabled={!canUpdateSettings}
            name="Modificar Logo"
            imageUrl={companyLogo.file_url}
            onChange={avatar => {
              setCompanyLogo(avatar);
              setLogoUpdateButton(true);
            }}
            helpText="Formato sugerido 620x400px de máximo 10mb."
            fileAccept=".png, .jpg, .gif, .jpeg"
          />
        </Col>
        <Col md={2} style={{ marginTop: '65px', marginLeft: '20px' }}>
          {logoUpdateButton && (
            <Button type="submit" className="btn" onClick={companyLogoUpdate}>
              Confirmar Logo
            </Button>
          )}
        </Col>
      </Row>
      <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
        <Nav variant="pills" className="as-tabs my-3">
          <Nav.Item>
            <Nav.Link eventKey="people">Gestión de Personas</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="time">Control del Tiempo</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="rem">Remuneraciones</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="people">
            <>
              <div className="as-section">
                <div className="block-header">Perfil Colaborador</div>
                <p className="text-muted mb-3">
                  En esta sección, usted podrá habilitar la visualización y uso de las solicitudes en el perfil del
                  trabajador
                </p>
                {renderGrid(employeeProfile, 3, listedSettings, cardBody)}
              </div>

              <div className="as-section">
                <div className="block-header">Notificaciones</div>
                <p className="text-muted mb-3">
                  En esta sección, usted podrá habilitar las notificaciones y recordatorios relacionados al modulo de
                  Gestión y Firma Digital.
                </p>
                {renderGrid(notifications, 3, listedSettings, cardBody)}
              </div>

              <div className="as-section">
                <div className="block-header">Otras Configuraciones</div>
                <p className="text-muted mb-3">
                  En esta sección, usted podrá realizar otras configuraciones para el funcionamiento de modulo.
                </p>
                <Row>
                  <Col xs={12}>
                    {(() => {
                      const sections = [];
                      sections.push(
                        <SettingsCard
                          key="advance"
                          size="100%"
                          colorCard="white"
                          classNameCard="z-index-auto mb-3"
                          divBody
                          bodyMarginBottom="-10px"
                          text={
                            <FormAdvancePayment
                              advanceSetting={advancePayment}
                              extraAction={() => {
                                const s = getSetting('advance_payment_request');
                                if (s) {
                                  settingUpdate(s);
                                }
                              }}
                            />
                          }
                        />
                      );

                      if (advancePaymentLoan.length > 0) {
                        sections.push(
                          <SettingsCard
                            key="loan"
                            size="100%"
                            colorCard="white"
                            classNameCard="z-index-auto mb-3"
                            divBody
                            bodyMarginBottom="-10px"
                            text={
                              <LoanFormSettings
                                amountData={advancePaymentLoan[0]}
                                percentageData={advancePaymentLoan[1]}
                                extraAction={() => {
                                  const s = getSetting('loan_request');
                                  if (s) {
                                    handleLoanSettingsUpdate(s);
                                  }
                                }}
                              />
                            }
                          />
                        );
                      }

                      if (isEnabled('overtime_requests') && overtimeRequests.length > 0) {
                        sections.push(
                          <SettingsCard
                            key="overtime"
                            size="100%"
                            colorCard="white"
                            classNameCard="z-index-auto mb-3"
                            divBody
                            bodyMarginBottom="-10px"
                            text={
                              <FormOvertimeRequests
                                hourValueData={overtimeRequests[0]}
                                handleSuccessUpdate={handleSuccessUpdate}
                              />
                            }
                          />
                        );
                      }
                      return sections.map((node, idx) => (
                        <React.Fragment key={`frag-${node.key}`}>
                          {node}
                          {idx < sections.length - 1 && <hr className="my-4" />}
                        </React.Fragment>
                      ));
                    })()}
                  </Col>
                </Row>
              </div>

              <div className="as-section">
                <div className="block-header">Credenciales API</div>
                <p>En esta sección, usted generar una nueva clave de conexión para conexiones con otros software.</p>
                {!isProfile && (
                  <Card>
                    <Card.Body>
                      <Row>
                        <Col xs={12} md={9}>
                          <Card.Title>Credenciales API</Card.Title>
                          <div className="info">
                            <span className="type">API KEY:</span>
                            <span className="line" />
                            <span className="answer"> {apiKey}</span>
                          </div>
                          <div className="info">
                            <span className="type">SECRET KEY:</span>
                            <span className="line" />
                            <span className="answer"> {showSecretKey ? currentSecretKey : hiddenSecretKey}</span>
                          </div>
                        </Col>
                        <Col sm={5} md={1} className="d-flex align-items-end mb-1">
                          <ButtonTooltip
                            onClick={() => setShowSecretKey(!showSecretKey)}
                            variant="circle-primary"
                            text={secretBtnMsg}
                          >
                            <Icon icon={secretBtnIcon} />
                          </ButtonTooltip>
                        </Col>
                        <Col sm={7} md={2} className="d-flex align-items-end mb-1">
                          <Button
                            variant="warning"
                            className="w-100 mt-1 mt-md-4"
                            onClick={handleNewSecretKeyModal}
                            disabled={onRequest}
                          >
                            Nueva secret key
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
              </div>
            </>
          </Tab.Pane>

          <Tab.Pane eventKey="time">
            <div className="as-section">
              <div className="block-header">Perfil Colaborador</div>
              <p className="text-muted mb-3">
                En esta sección, usted podrá habilitar la visualización y uso de las solicitudes en el perfil del
                trabajador
              </p>
              {renderGrid(ctEmployeeProfile, 3, listedSettings, cardBody)}
            </div>

            <div className="as-section">
              <div className="block-header">Notificaciones</div>
              <p className="text-muted mb-3">
                En esta sección, usted podrá habilitar las notificaciones y recordatorios relacionado al modulo de
                Control del Tiempo.
              </p>
              {renderGrid(ctNotifications, 3, listedSettings, cardBody)}
            </div>

            <div className="as-section">
              <div className="block-header">Otras Configuraciones</div>
              <p className="text-muted mb-3">
                En esta sección, usted podrá realizar otras configuraciones para el funcionamiento de modulo.
              </p>
              <Col xs={12}>{renderGrid(ctAdditionalSettings, 2, listedSettings, cardBody)} </Col>
              <Col xs={12}><Row>
                {isEnabled('night_shift_range') && nightShiftSettings.length > 0 && (
                  <SettingsCard
                    key="nightshift"
                    size="100%"
                    colorCard="white"
                    classNameCard="z-index-auto mb-3"
                    divBody
                    bodyMarginBottom="-10px"
                    text={
                      <FormNightShiftSettings
                        advanceSetting={nightShiftSettings}
                        handleSuccessUpdate={handleSuccessUpdate}
                      // extraAction={() => {
                      //   const s = getSetting('advance_payment_request');
                      //   if (s) {
                      //     settingUpdate(s);
                      //   }
                      // }}
                      />
                    }
                  />
                )}
              </Row>
              </Col>
            </div>
          </Tab.Pane>

          <Tab.Pane eventKey="rem">
            <div className="as-section">
              <div className="block-header">Gratificación Artículo 47</div>
              <p className="text-muted mb-3">
                En esta sección, usted podrá habilitar los parámetros necesarios para el cálculo de la gratificación
                anual.
              </p>

              <SettingsCard
                size="100%"
                colorCard="white"
                classNameCard="z-index-auto mb-3"
                divBody
                bodyMarginBottom="-10px"
                text={
                  <AnnualGratificationSettingsForm
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    yearOptions={yearOptions}
                    formRequest={handleSubmit}
                    dispatch={dispatch}
                  />
                }
              />
            </div>
            <div className="as-section">
              <div className="block-header">Condicion Cuentas Contables</div>
              <p className="text-muted mb-3">
                En esta sección, usted incluir el parametrizar la condición de asociación en la configuración de las
                cuentas contables.
              </p>

              {renderRemGrid(listedRemunerationsSettings, 2, body =>
                remCardBody(body, settingData, canUpdateSettings, conditionsEnum, changeSettingSelector, settingUpdate)
              )}
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container >

      {
        currentCompany.allowDownload && ability.can('export', 'Company') && (
          <Row>
            <Col xs={12} md={6}>
              <h4 className="text-uppercase mb-2">Exportar Empresa</h4>
              {currentCompany.availableDownload ? (
                <p className="text-muted">
                  Peoplework ha autorizado la exportación de la información de tu empresa. Este permiso estará vigente
                  hasta {currentCompany.zipRequestEndDate}.
                </p>
              ) : (
                <p className="text-muted">
                  Ya has iniciado la exportación de información de tu empresa. Recibirás un email con el link de descarga
                  cuando el proceso este finalizado.
                </p>
              )}
              <SettingsCard
                size="100%"
                bodyMarginBottom="-10px"
                colorCard="white"
                divBody
                text={
                  <Row>
                    <Col md={8} xs={6}>
                      <p className="text-uppercase mt-1" style={{ letterSpacing: '1.5px' }}>
                        Exportar Empresa
                      </p>
                    </Col>
                    <Col xs={6} md={4}>
                      {currentCompany.availableDownload ? (
                        <Button onClick={() => handleModal(downloadModalBody(), 'Comenzar Exportación de Empresa')}>
                          Comenzar Exportación
                        </Button>
                      ) : (
                        <p className="mt-1 font-weight-bold text-primary text-uppercase">Comenzado</p>
                      )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        )
      }

      {
        onRequest && (
          <div className="containerSpinnerLoad">
            <Spinner animation="border" variant="primary" />
          </div>
        )
      }
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        modalSize="lg"
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleConfirm={modalHandleConfirm}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={onRequest}
        withClose={modalsWithButtons.indexOf(modalTitle) > -1}
        withConfirm={modalsWithButtons.indexOf(modalTitle) > -1}
      />
      <DefaultModal
        title={modalTitleApiCredentials}
        body={modalBodyApiCredentials}
        show={modalShowApiCredentials}
        handleClose={() => setModalShowApiCredentials(false)}
        handleConfirm={handleNewSecretKeyRequest}
        titleBtnClose={closeBtnMsg}
        titleBtnSave="Confirmar"
        withConfirm={withModalConfirm}
        withClose={false}
      />
    </>
  );
};

export default AdvanceSettings;
